export const MST_ENDPOINT_TYPE = 'mst'
export const SHARED_ENDPOINT_TYPE = 'shared'
export const WEB_ENDPOINT_TYPE = 'web'
